import  gql  from 'graphql-tag'

export const creditRequestStages = gql`query creditRequestStages($isActive: Boolean){ 
    creditRequestStages(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
